import React, { useEffect } from 'react'
import ReactPixel from 'react-facebook-pixel'
import ProMain from './ProMain'
import Footer from '../Home/Footer'
import ProAdv from './ProAdvantages'
import ProLoc from './ProLocations'
import ProSub from './Subscribe'
import ProMember from '../Home/Testimony'
import { useAnchorAutoScroll } from '../../utils/Utils'
import QuestionsAnswersViewer from '../../components/QuestionsAnswersViewer'

const Pro = () => {
  useAnchorAutoScroll()
  useEffect(() => {
    ReactPixel.pageView()
  }, [])

  return (
    <>
      <ProMain />
      <ProAdv />
      {window.innerWidth < 480 ? (
        <></>
      ) : (
        <>
          <ProSub buttonId="inscription_viewerpro" />
        </>
      )}
      <ProLoc />
      <QuestionsAnswersViewer from="pro" />
      {window.innerWidth < 480 ? (
        <></>
      ) : (
        <>
          <ProMember />
        </>
      )}
      <Footer />
    </>
  )
}

export default Pro
